import { render, staticRenderFns } from "./menuIcon.vue?vue&type=template&id=034994ae&scoped=true&"
import script from "./menuIcon.vue?vue&type=script&lang=js&"
export * from "./menuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034994ae",
  null
  
)

export default component.exports